"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.WSClient = exports.WSClientState = void 0;
var WSClientState;
(function (WSClientState) {
    WSClientState[WSClientState["Connecting"] = 0] = "Connecting";
    WSClientState[WSClientState["Connected"] = 1] = "Connected";
    WSClientState[WSClientState["Disconnecting"] = 2] = "Disconnecting";
    WSClientState[WSClientState["Disconnected"] = 3] = "Disconnected";
})(WSClientState = exports.WSClientState || (exports.WSClientState = {}));
var CLOSE_NORMAL = 1000;
var WSClient = (function () {
    function WSClient(settings) {
        if (settings === void 0) { settings = WSClient.defaultSettings; }
        this._state = WSClientState.Disconnected;
        this._settings = __assign(__assign({}, WSClient.defaultSettings), settings);
        this._url = undefined;
        this._protocols = [];
        this._attempts = 0;
        this._forceClose = false;
        this._state = WSClientState.Disconnected;
    }
    Object.defineProperty(WSClient.prototype, "state", {
        get: function () {
            return this._state;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(WSClient.prototype, "url", {
        get: function () {
            return this._url;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(WSClient.prototype, "protocols", {
        get: function () {
            return this._protocols;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(WSClient.prototype, "reconnectAttemps", {
        get: function () {
            return this._attempts;
        },
        enumerable: false,
        configurable: true
    });
    WSClient.prototype.tryOpen = function () {
        var _this = this;
        if (this._settings.maxReconnectAttempts && this._attempts >= this._settings.maxReconnectAttempts) {
            this._state = WSClientState.Disconnected;
            if (this.onDisconnect) {
                this.onDisconnect(CLOSE_NORMAL);
            }
            return;
        }
        var ws = new WebSocket(this._url, this._protocols);
        this._ws = ws;
        var timedOut = false;
        var timeout = setTimeout(function () {
            timedOut = true;
            _this._ws.close();
            timedOut = false;
        }, this._settings.connectTimeout);
        ws.onopen = function (event) {
            clearTimeout(timeout);
            _this._state = WSClientState.Connected;
            _this._attempts = 0;
            if (_this.onConnect) {
                _this.onConnect();
            }
        };
        ws.onclose = function (event) {
            clearTimeout(timeout);
            _this._ws = undefined;
            if (_this._forceClose) {
                _this._state = WSClientState.Disconnected;
                if (_this.onDisconnect) {
                    _this.onDisconnect(event.code);
                }
                return;
            }
            _this._state = WSClientState.Connecting;
            if (_this.onConnecting) {
                _this.onConnecting(event.code);
            }
            var reconnectTimeout = _this._settings.reconnectInterval * Math.pow(_this._settings.reconnectDecay, _this._attempts);
            setTimeout(function () {
                _this._attempts++;
                _this.tryOpen();
            }, reconnectTimeout > _this._settings.maxReconnectInterval ? _this._settings.maxReconnectInterval : reconnectTimeout);
        };
        ws.onerror = function (event) {
            if (_this.onError) {
                _this.onError(event);
            }
        };
        ws.onmessage = function (event) {
            if (_this.onMessage) {
                _this.onMessage(event.data);
            }
        };
    };
    WSClient.prototype.open = function (url, protocols) {
        if (protocols === void 0) { protocols = []; }
        this.close();
        this._forceClose = false;
        this._attempts = 0;
        this._url = url;
        this._protocols = protocols;
        this.tryOpen();
    };
    WSClient.prototype.close = function () {
        if (!this._ws) {
            return;
        }
        this._state = WSClientState.Disconnecting;
        this._forceClose = true;
        this._ws.close(CLOSE_NORMAL);
    };
    WSClient.prototype.send = function (data) {
        if (!this._ws || this._state !== WSClientState.Connected) {
            throw new Error('WebSocket is not yet available.');
        }
        this._ws.send(data);
    };
    WSClient.defaultSettings = {
        reconnectInterval: 1000,
        maxReconnectInterval: 15000,
        reconnectDecay: 1.5,
        connectTimeout: 2000,
        maxReconnectAttempts: undefined,
    };
    return WSClient;
}());
exports.WSClient = WSClient;
//# sourceMappingURL=wsclient.js.map